
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"32","height":"32","rx":"16","fill":"#6C7073"}}),_c('path',{attrs:{"d":"M11 11l10 10M21 11L11 21","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round"}})])
      }
    
      }
    